import { Pipe, PipeTransform } from '@angular/core';
import { CompanyType } from '@core/enum/company-type.enum';

@Pipe({ name: 'companyTypePipe' })
export class CompanyTypePipe implements PipeTransform {
  transform(value: string | undefined): string {
    switch (value) {
      case CompanyType.MANAGER:
        return 'Operadora';
      case CompanyType.CLIENT:
        return 'Cliente';
      default:
        return value ? value : '';
    }
  }
}
